import * as React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Avatar from '@material-ui/core/Avatar';
import TextField from '@material-ui/core/TextField';
import Container from '@material-ui/core/Container';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import EmailIcon from '@material-ui/icons/Email';
import { CardHeader, Typography } from '@material-ui/core';
import Header from '../layouts/Header';

export interface ForgotLinkPageViewProps {
    saveUsername: (username: string) => void;
    onSubmit: () => void;
    userName: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            overflow: 'auto'
        },
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120,
            width: '100%'
        },
        paper: {
            marginTop: theme.spacing(8),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        avatar: {
            margin: theme.spacing(1),
            backgroundColor: theme.palette.secondary.main
        },
        form: {
            width: '100%', // Fix IE 11 issue.
            marginTop: theme.spacing(1),
            textAlign: 'center'
        },
        submit: {
            margin: theme.spacing(3, 1, 2, 1),
            alignItems: 'center'
        },
        rating: {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        textShift: {
            marginLeft: theme.spacing(1)
        }
    })
);

const ForgotLinkPageView: React.StatelessComponent<ForgotLinkPageViewProps> = props => {
    const classes = useStyles({});

    return (
        <div className={classes.root}>
            <Header />
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <div className={classes.paper}>
                    <CardHeader
                        avatar={
                            <Avatar aria-label="recipe" className={classes.avatar}>
                                <EmailIcon />
                            </Avatar>}
                        title={<h2>Forgot your password ?</h2>}
                    />
                    <form className={classes.form} noValidate>
                        <Typography
                            className={classes.textShift}
                            color="textPrimary"
                            gutterBottom
                            variant="caption"
                        >
                            Enter your username that you used to login. We'll send you an email with a link to reset your password.
                        </Typography>
                        <FormControl variant="outlined" className={classes.formControl}>
                            <TextField
                                variant="outlined"
                                label="Username"
                                onChange={event => props.saveUsername(event.target.value)}
                                value={props.userName}
                            />
                        </FormControl>
                        <Button
                            type="button"
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                            onClick={props.onSubmit}
                        >
                            Send Verification Mail
                        </Button>
                    </form>
                </div>
            </Container>
        </div >
    );
};

export default ForgotLinkPageView;



// WEBPACK FOOTER //
// ./src/components/layouts/ForgotPasswordLinkView.tsx